import React from "react"
import { Spinner } from "react-bootstrap"

interface IProps {
    text?: string;
    backgroundvisible?:boolean;
  }

const SpinnerEditeurPro: React.FC<IProps> = ({ text,backgroundvisible }) => {

return <div className={`d-flex justify-content-center mt-2 ${backgroundvisible ?"bg-whitegrey card pae-detail-pub-card" : "" }`}>
          <div>
            <div className="card-body pae-form-container">
              <Spinner animation="border" className="text-whitegrey spinner-grow m-1" />
              <Spinner animation="border" className="text-bluelight spinner-grow m-1" />
              <Spinner animation="border" className="text-bluemiddle spinner-grow m-1" />
              <div className="titreModule text-center ">{text ? text : "Chargement..."}</div>
            </div>
          </div>
        </div>
}


export default SpinnerEditeurPro;
